const NAME = 'PERKS';

export const getFeaturedPerk = (store) => store[NAME].list.featuredPerk;
export const getPerk = (store) => store[NAME].info;
export const getPerks = (store) => store[NAME].list.data;
export const getRedeemedPerks = (store) => store[NAME].redeemed;
export const getCreatedPerks = (store) => store[NAME].created;
export const getPerksCacheExp = (store) => store[NAME].list.exp;
export const perksPageMeta = (store) => store[NAME].list.page;
